import qs from "qs";
import axios from "axios";
import Jsona from "jsona";

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
  const options = {
    params: params,
    paramsSerializer: function (params) {
      return qs.stringify(params, { encode: false });
    },
  };

  return axios.get(`${url}/signatures`, options).then((response) => {
    return {
      list: jsona.deserialize(response.data),
      meta: response.data.meta,
    };
  });
}

function get(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .get(
      `${url}/signatures/${id}`,
      options
    )
    .then((response) => {
      let signature = jsona.deserialize(response.data);
      delete signature.links;
      return signature;
    });
}


function getSignedDocuments(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };
  return axios
    .get(
      `${url}/signatures/${id}/download-signed-documents`,
      options
    )
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}

function add(signature) {
  const payload = jsona.serialize({
    stuff: signature,
    includeNames: null,
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .post(`${url}/signatures?include=`, payload, options)
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}

function update(signature) {
  const payload = jsona.serialize({
    stuff: signature,
    includeNames: [],
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .patch(`${url}/signatures/${signature.id}?include=`, payload, options)
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}

function send(signature) {
  const payload = jsona.serialize({
    stuff: signature,
    includeNames: [],
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .patch(`${url}/signatures/${signature.id}/send`, payload, options)
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}

function destroy(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios.delete(`${url}/signatures/${id}`, options);
}

export default {
  list,
  get,
  add,
  update,
  destroy,
  send,
  getSignedDocuments
};
